"use client";

import Button from "@/components/Button";
import { motion, useInView } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";

export default function KickstartCTASection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount: 0.3 });

	return (
		<section ref={ref} className="relative py-16 md:py-24 overflow-hidden">
			<div className="absolute inset-0">
				<Image
					src="/assets/program.png"
					alt="Football on field"
					fill
					className="object-cover"
				/>
				<div className="absolute inset-0 bg-black/70" />
			</div>

			<div className="container mx-auto px-4 relative z-10">
				<div className="max-w-2xl">
					<motion.div
						initial={{ opacity: 0, scale: 0.95 }}
						animate={
							isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }
						}
						transition={{ duration: 0.8, ease: "easeOut" }}
						className="bg-black/40 backdrop-blur-sm rounded-2xl p-8 md:p-12"
					>
						<motion.h2
							initial={{ opacity: 0, y: 20 }}
							animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
							transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
							className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
						>
							KICKSTART YOUR
							<br />
							<span className="text-primary">FOOTBALL CAREER</span>
							<br />
							WITH RFFA
						</motion.h2>

						<motion.p
							initial={{ opacity: 0, y: 20 }}
							animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
							transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
							className="text-white/90 leading-relaxed mb-8"
						>
							Football is more than a game, it&apos;s a journey. Our academy
							creates a supportive environment where young talents grow
							together, improve their skills, and form lasting friendships both
							on and off the pitch.
						</motion.p>

						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
							transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
						>
							<Button href="/registration">Register Now</Button>
						</motion.div>
					</motion.div>
				</div>
			</div>
		</section>
	);
}
